import { render, staticRenderFns } from "./UserRecoverySimple.vue?vue&type=template&id=7af2d46a&"
import script from "./UserRecoverySimple.vue?vue&type=script&lang=js&"
export * from "./UserRecoverySimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports